import { defineMessages } from 'react-intl';

/** The copy of the Assets tab of Releases v2 (design c1, c3, e3, e4). The UI word is "revision" (owner answer 1). */
export const revisionCardMessages = defineMessages({
  revision: { id: 'app.sml.releases.assets.revision', defaultMessage: 'r{revision}' },
  newTag: { id: 'app.sml.releases.assets.new', defaultMessage: 'New' },
  stateReady: { id: 'app.sml.releases.assets.state.ready', defaultMessage: 'Ready' },
  statePosted: { id: 'app.sml.releases.assets.state.posted', defaultMessage: 'Posted' },
  stateScheduled: { id: 'app.sml.releases.assets.state.scheduled', defaultMessage: 'Scheduled' },
  stateQueued: { id: 'app.sml.releases.assets.state.queued', defaultMessage: 'Queued' },
  stateRendering: { id: 'app.sml.releases.assets.state.rendering', defaultMessage: 'Rendering · {progress}%' },
  stateFailed: { id: 'app.sml.releases.assets.state.failed', defaultMessage: 'Failed' },
  stateOldTheme: { id: 'app.sml.releases.assets.state.oldTheme', defaultMessage: 'Old theme' },
  stillReady: { id: 'app.sml.releases.assets.stillReady', defaultMessage: 'r{revision} is still ready' },
  staysReady: {
    id: 'app.sml.releases.assets.staysReady',
    defaultMessage: 'r{ready} stays ready until r{revision} is done',
  },
  noOlder: { id: 'app.sml.releases.assets.noOlder', defaultMessage: 'No older revision' },
  oldThemeLine: { id: 'app.sml.releases.assets.oldThemeLine', defaultMessage: '{theme} · the song is {current} now' },
  openRevision: { id: 'app.sml.releases.assets.openRevision', defaultMessage: 'Open r{revision}' },
  tryAgain: { id: 'app.sml.releases.assets.tryAgain', defaultMessage: 'Try again' },
  inTheme: { id: 'app.sml.releases.assets.inTheme', defaultMessage: 'In {theme}' },
  seeInAssets: { id: 'app.sml.releases.assets.seeWork', defaultMessage: 'See the work' },
  open: { id: 'app.sml.releases.assets.open', defaultMessage: 'Open {name}' },
  download: { id: 'app.sml.releases.assets.download', defaultMessage: 'Download {name}' },
  post: { id: 'app.sml.releases.assets.post', defaultMessage: 'Post {name}' },
  newRevision: { id: 'app.sml.releases.assets.newRevision', defaultMessage: 'New revision of {name}' },
  filterAll: { id: 'app.sml.releases.assets.filter.all', defaultMessage: 'All' },
  filterImages: { id: 'app.sml.releases.assets.filter.images', defaultMessage: 'Images' },
  filterShort: { id: 'app.sml.releases.assets.filter.short', defaultMessage: 'Short videos' },
  filterFull: { id: 'app.sml.releases.assets.filter.full', defaultMessage: 'Full videos' },
  filterReels: { id: 'app.sml.releases.assets.filter.reels', defaultMessage: 'AI reels' },
  filterLabel: { id: 'app.sml.releases.assets.filter.label', defaultMessage: 'Asset type' },
  stateLabel: { id: 'app.sml.releases.assets.filter.stateLabel', defaultMessage: 'State' },
  stateAll: { id: 'app.sml.releases.assets.filter.stateAll', defaultMessage: 'All states' },
  stateWorking: { id: 'app.sml.releases.assets.filter.stateWorking', defaultMessage: 'Working' },
  sortLabel: { id: 'app.sml.releases.assets.sort.label', defaultMessage: 'Order' },
  sortNewest: { id: 'app.sml.releases.assets.sort.newest', defaultMessage: 'Newest first' },
  sortType: { id: 'app.sml.releases.assets.sort.type', defaultMessage: 'By type' },
  justMade: { id: 'app.sml.releases.assets.justMade', defaultMessage: 'Just made' },
  justMadeSince: {
    id: 'app.sml.releases.assets.justMadeSince',
    defaultMessage: '{count} since you were here · {date}',
  },
  justMadeFirst: {
    id: 'app.sml.releases.assets.justMadeFirst',
    defaultMessage: '{count} in the last 7 days',
  },
  markSeen: { id: 'app.sml.releases.assets.markSeen', defaultMessage: 'Mark all as seen' },
  groupMeta: { id: 'app.sml.releases.assets.groupMeta', defaultMessage: '{count}' },
  emptyTitle: { id: 'app.sml.releases.assets.empty.title', defaultMessage: 'Nothing made for this song yet.' },
  emptyBody: {
    id: 'app.sml.releases.assets.empty.body',
    defaultMessage: 'Make stories, posts, cover sizes and videos in the theme of the song. They show up here.',
  },
  openStudio: { id: 'app.sml.releases.assets.empty.openStudio', defaultMessage: 'Open Studio' },
  noMatchTitle: { id: 'app.sml.releases.assets.noMatch.title', defaultMessage: 'No assets match.' },
  clearFilters: { id: 'app.sml.releases.assets.noMatch.clear', defaultMessage: 'Clear the filters' },
});
